import type { ReactNode } from "react";
import { useHudStore } from "../store/hudStore";
import { computeView } from "../store/selectors";
import TopBar from "./TopBar";
import Footer from "./Footer";
import { Button } from "../design-system/components";

// Shared drill-in frame: TopBar + back link + content + footer, all in one
// column of --shell-max. The content area grows (flex:1) so the footer stays at
// the column's bottom without ever overlapping the last row.
export default function Page({ back, onBack, children }: { back: string; onBack?: () => void; children: ReactNode }) {
  const st = useHudStore();
  const v = computeView(st);
  return (
    <div className="page-frame">
      <TopBar v={v} />
      <div className="page-sections">
        <Button className="page-back" variant="quiet" size="compact" icon="fa-solid fa-arrow-left" onClick={onBack ?? st.goHud}>{back}</Button>
        {children}
      </div>
      <Footer />
    </div>
  );
}
